import { Component, Inject } from '@angular/core';
import { Globals } from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'SMS';

  constructor(public globals: Globals) {
    // has session 
    this.globals.loadUserInfo();
    // if (localStorage.getItem('loggedIn')) {
    //   this.globals.loggedIn = true;
    // }
    // else {
    //   this.globals.loggedIn = false;
    // }
  }
}
